// extracted by mini-css-extract-plugin
export default {"lib-header":"library_lib-header__0H+N-","lib-body":"library_lib-body__V1nNa"};